export default __webpack_public_path__ + "static/landing_dark-7894fa8dbbc67e07779353d6c54b5280.png";